// const api = "http://localhost:1339/api";
// const host = "http://localhost:1339";

const api = "https://sisis-api.wsio-api.com/api";
const host = "https://sisis-api.wsio-api.com";

const apiShop = "https://howardson-api.wsio-api.com/api";
const hostShop = "https://howardson-api.wsio-api.com";

const locales = [];
const loqateKey = "AY75-WB66-NW49-BF43";

export { api, apiShop, host, hostShop, locales, loqateKey };